<template>
  <div class="uploader-section">
    <header class="uploader-section__title">
      {{ title }}
    </header>
    <p
      v-dompurify-html="description"
      class="text-small uploader-section__description"
    />

    <slot />

    <ul v-if="limits" class="uploader-section__limits">
      <li v-for="item in limits" :key="item.name">
        <span>{{ item.name }}:</span>
        <span class="text-latin">{{ item.value }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'UploaderSection',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    limits: {
      type: Array,
      default: null,
    },
  },
};
</script>

<style lang="scss">
.uploader-section {
  color: $concrete;

  &__title {
    font-weight: bold;
    margin-bottom: $global-margin;
  }

  &__limits {
    font-size: 90%;
    list-style: none;
    margin: $global-margin 0;
    padding: 0;
  }
}

.uploader-section + .uploader-section {
  margin-top: $global-margin * 3;
}
</style>
